import { createContext, useContext, ReactNode } from 'react';

export interface PrefillPetData {
  id?: string;
  name?: string;
  species?: string;
  breed?: string;
  gender?: string;
}

interface AddPetModalContextValue {
  openAddPet: (prefill?: PrefillPetData) => void;
}

const AddPetModalContext = createContext<AddPetModalContextValue | null>(null);

export function AddPetModalProvider({
  children,
  openAddPet,
}: {
  children: ReactNode;
  openAddPet: (prefill?: PrefillPetData) => void;
}) {
  return (
    <AddPetModalContext.Provider value={{ openAddPet }}>
      {children}
    </AddPetModalContext.Provider>
  );
}

export function useAddPetModal(): AddPetModalContextValue | null {
  return useContext(AddPetModalContext);
}
